export type PayPeriod = "HOURLY" | "DAILY" | "WEEKLY" | "MONTHLY" | "YEARLY";
export type PayBounds = [number, number];

export const payBoundsByCountry: Record<string, Record<PayPeriod, PayBounds>> = {
  AE: {
    HOURLY: [1, 4158],
    DAILY: [1, 33260],
    WEEKLY: [1, 166297],
    MONTHLY: [1, 692902],
    YEARLY: [1, 8314822],
  },
  AQ: {
    HOURLY: [1, 500000],
    DAILY: [1, 4000000],
    WEEKLY: [1, 20000000],
    MONTHLY: [1, 83333334],
    YEARLY: [1, 1000000000],
  },
  AR: {
    HOURLY: [1, 18305],
    DAILY: [1, 146444],
    WEEKLY: [1, 732218],
    MONTHLY: [1, 3050910],
    YEARLY: [1, 36610920],
  },
  AT: {
    HOURLY: [1, 1588],
    DAILY: [1, 12221],
    WEEKLY: [1, 61104],
    MONTHLY: [1, 254602],
    YEARLY: [1, 3055219],
  },
  AU: {
    HOURLY: [1, 3825],
    DAILY: [1, 30596],
    WEEKLY: [1, 152978],
    MONTHLY: [1, 637409],
    YEARLY: [1, 7648896],
  },
  BE: {
    HOURLY: [1, 1837],
    DAILY: [1, 13960],
    WEEKLY: [1, 69795],
    MONTHLY: [1, 290811],
    YEARLY: [1, 3489732],
  },
  BH: {
    HOURLY: [1, 501000],
    DAILY: [1, 4008004],
    WEEKLY: [1, 20040020],
    MONTHLY: [1, 83500084],
    YEARLY: [1, 1002001000],
  },
  BR: {
    HOURLY: [1, 1260],
    DAILY: [1, 11082],
    WEEKLY: [1, 55407],
    MONTHLY: [1, 230861],
    YEARLY: [1, 2770337],
  },
  CA: {
    HOURLY: [1, 2913],
    DAILY: [1, 23297],
    WEEKLY: [1, 116485],
    MONTHLY: [1, 485352],
    YEARLY: [1, 5824221],
  },
  CH: {
    HOURLY: [1, 3174],
    DAILY: [1, 25393],
    WEEKLY: [1, 126966],
    MONTHLY: [1, 529026],
    YEARLY: [1, 6348312],
  },
  CL: {
    HOURLY: [1, 355673],
    DAILY: [1, 2845382],
    WEEKLY: [1, 14226907],
    MONTHLY: [1, 59278779],
    YEARLY: [1, 711345344],
  },
  CN: {
    HOURLY: [1, 3358],
    DAILY: [1, 26862],
    WEEKLY: [1, 134309],
    MONTHLY: [1, 559617],
    YEARLY: [1, 6715401],
  },
  CO: {
    HOURLY: [1, 522450],
    DAILY: [1, 4179594],
    WEEKLY: [1, 25077558],
    MONTHLY: [1, 104489821],
    YEARLY: [1, 1253877847],
  },
  CR: {
    HOURLY: [1, 500490],
    DAILY: [1, 4003920],
    WEEKLY: [1, 20019600],
    MONTHLY: [1, 83415001],
    YEARLY: [1, 1000980000],
  },
  CZ: {
    HOURLY: [1, 16042],
    DAILY: [1, 128336],
    WEEKLY: [1, 641679],
    MONTHLY: [1, 2673658],
    YEARLY: [1, 32083890],
  },
  DE: {
    HOURLY: [1, 2632],
    DAILY: [1, 21049],
    WEEKLY: [1, 105239],
    MONTHLY: [1, 438493],
    YEARLY: [1, 5261917],
  },
  DK: {
    HOURLY: [1, 576792],
    DAILY: [1, 4268256],
    WEEKLY: [1, 21341280],
    MONTHLY: [1, 88922001],
    YEARLY: [1, 1067064000],
  },
  EC: {
    HOURLY: [1, 522242],
    DAILY: [1, 4177936],
    WEEKLY: [1, 20889680],
    MONTHLY: [1, 87040334],
    YEARLY: [1, 1044484000],
  },
  EG: {
    HOURLY: [1, 3030],
    DAILY: [1, 24240],
    WEEKLY: [1, 121202],
    MONTHLY: [1, 505008],
    YEARLY: [1, 6060096],
  },
  ES: {
    HOURLY: [1, 863],
    DAILY: [1, 6908],
    WEEKLY: [1, 34540],
    MONTHLY: [1, 143916],
    YEARLY: [1, 1726991],
  },
  FI: {
    HOURLY: [1, 553905],
    DAILY: [1, 4209680],
    WEEKLY: [1, 21048400],
    MONTHLY: [1, 87701667],
    YEARLY: [1, 1052420000],
  },
  FR: {
    HOURLY: [1, 1979],
    DAILY: [1, 13848],
    WEEKLY: [1, 69241],
    MONTHLY: [1, 288499],
    YEARLY: [1, 3461990],
  },
  GB: {
    HOURLY: [1, 1595],
    DAILY: [1, 12757],
    WEEKLY: [1, 63782],
    MONTHLY: [1, 265756],
    YEARLY: [1, 3189074],
  },
  GR: {
    HOURLY: [1, 534046],
    DAILY: [1, 4272368],
    WEEKLY: [1, 21361840],
    MONTHLY: [1, 89007667],
    YEARLY: [1, 1068092000],
  },
  HK: {
    HOURLY: [1, 10848],
    DAILY: [1, 86784],
    WEEKLY: [1, 433920],
    MONTHLY: [1, 1808001],
    YEARLY: [1, 21696012],
  },
  HU: {
    HOURLY: [1, 170489],
    DAILY: [1, 1363910],
    WEEKLY: [1, 6819550],
    MONTHLY: [1, 28414791],
    YEARLY: [1, 340977489],
  },
  ID: {
    HOURLY: [1, 4304846],
    DAILY: [1, 34438770],
    WEEKLY: [1, 172193850],
    MONTHLY: [1, 717474375],
    YEARLY: [1, 8609692500],
  },
  IE: {
    HOURLY: [1, 2464],
    DAILY: [1, 19705],
    WEEKLY: [1, 98523],
    MONTHLY: [1, 410511],
    YEARLY: [1, 4926138],
  },
  IL: {
    HOURLY: [1, 492572],
    DAILY: [1, 4334624],
    WEEKLY: [1, 21673120],
    MONTHLY: [1, 90304667],
    YEARLY: [1, 1083656000],
  },
  IN: {
    HOURLY: [1, 15988],
    DAILY: [1, 127905],
    WEEKLY: [1, 767425],
    MONTHLY: [1, 3197603],
    YEARLY: [1, 38371232],
  },
  IT: {
    HOURLY: [1, 1394],
    DAILY: [1, 11147],
    WEEKLY: [1, 55733],
    MONTHLY: [1, 232216],
    YEARLY: [1, 2786589],
  },
  JP: {
    HOURLY: [1, 132438],
    DAILY: [1, 1059497],
    WEEKLY: [1, 5297480],
    MONTHLY: [1, 22072831],
    YEARLY: [1, 264873975],
  },
  KR: {
    HOURLY: [1, 1851534],
    DAILY: [1, 14812271],
    WEEKLY: [1, 74061349],
    MONTHLY: [1, 308588953],
    YEARLY: [1, 3703067435],
  },
  KW: {
    HOURLY: [1, 531476],
    DAILY: [1, 4251808],
    WEEKLY: [1, 21259040],
    MONTHLY: [1, 88579334],
    YEARLY: [1, 1062952000],
  },
  LU: {
    HOURLY: [1, 523770],
    DAILY: [1, 4190160],
    WEEKLY: [1, 20950800],
    MONTHLY: [1, 87295001],
    YEARLY: [1, 1047540000],
  },
  MA: {
    HOURLY: [1, 612926],
    DAILY: [1, 4290480],
    WEEKLY: [1, 21452400],
    MONTHLY: [1, 89385001],
    YEARLY: [1, 1072620000],
  },
  MX: {
    HOURLY: [1, 5106],
    DAILY: [1, 40840],
    WEEKLY: [1, 245036],
    MONTHLY: [1, 1020983],
    YEARLY: [1, 12251785],
  },
  MY: {
    HOURLY: [1, 2533],
    DAILY: [1, 20265],
    WEEKLY: [1, 101324],
    MONTHLY: [1, 422185],
    YEARLY: [1, 5066220],
  },
  NG: {
    HOURLY: [1, 830502],
    DAILY: [1, 6644016],
    WEEKLY: [1, 33220080],
    MONTHLY: [1, 138417001],
    YEARLY: [1, 1661004000],
  },
  NL: {
    HOURLY: [1, 2043],
    DAILY: [1, 16339],
    WEEKLY: [1, 81692],
    MONTHLY: [1, 340383],
    YEARLY: [1, 4084587],
  },
  NO: {
    HOURLY: [1, 544380],
    DAILY: [1, 4355040],
    WEEKLY: [1, 21775200],
    MONTHLY: [1, 90730001],
    YEARLY: [1, 1088760000],
  },
  NZ: {
    HOURLY: [1, 2604],
    DAILY: [1, 20828],
    WEEKLY: [1, 104138],
    MONTHLY: [1, 433908],
    YEARLY: [1, 5206900],
  },
  OM: {
    HOURLY: [1, 510050],
    DAILY: [1, 4080400],
    WEEKLY: [1, 20402000],
    MONTHLY: [1, 85008334],
    YEARLY: [1, 1020100000],
  },
  PA: {
    HOURLY: [1, 515112],
    DAILY: [1, 4120900],
    WEEKLY: [1, 20604500],
    MONTHLY: [1, 85852084],
    YEARLY: [1, 1030225000],
  },
  PE: {
    HOURLY: [1, 1220],
    DAILY: [1, 9754],
    WEEKLY: [1, 48765],
    MONTHLY: [1, 203186],
    YEARLY: [1, 2438235],
  },
  PH: {
    HOURLY: [1, 6511],
    DAILY: [1, 52082],
    WEEKLY: [1, 260404],
    MONTHLY: [1, 1085016],
    YEARLY: [1, 13020188],
  },
  PK: {
    HOURLY: [1, 9922],
    DAILY: [1, 79378],
    WEEKLY: [1, 476268],
    MONTHLY: [1, 1984447],
    YEARLY: [1, 23813361],
  },
  PL: {
    HOURLY: [1, 2435],
    DAILY: [1, 19483],
    WEEKLY: [1, 97416],
    MONTHLY: [1, 405899],
    YEARLY: [1, 4870786],
  },
  PT: {
    HOURLY: [1, 470],
    DAILY: [1, 3751],
    WEEKLY: [1, 18755],
    MONTHLY: [1, 78144],
    YEARLY: [1, 937723],
  },
  QA: {
    HOURLY: [1, 5890],
    DAILY: [1, 47115],
    WEEKLY: [1, 235573],
    MONTHLY: [1, 981552],
    YEARLY: [1, 11778627],
  },
  RO: {
    HOURLY: [1, 578624],
    DAILY: [1, 4628988],
    WEEKLY: [1, 23144940],
    MONTHLY: [1, 96437251],
    YEARLY: [1, 1157247000],
  },
  RU: {
    HOURLY: [1, 14430],
    DAILY: [1, 115442],
    WEEKLY: [1, 577210],
    MONTHLY: [1, 2405039],
    YEARLY: [1, 28860466],
  },
  SA: {
    HOURLY: [1, 2836],
    DAILY: [1, 27225],
    WEEKLY: [1, 136122],
    MONTHLY: [1, 567173],
    YEARLY: [1, 6806080],
  },
  SE: {
    HOURLY: [1, 18804],
    DAILY: [1, 150433],
    WEEKLY: [1, 752163],
    MONTHLY: [1, 3134011],
    YEARLY: [1, 37608137],
  },
  SG: {
    HOURLY: [1, 2830],
    DAILY: [1, 22636],
    WEEKLY: [1, 113176],
    MONTHLY: [1, 471565],
    YEARLY: [1, 5658774],
  },
  TH: {
    HOURLY: [1, 30633],
    DAILY: [1, 245065],
    WEEKLY: [1, 1470390],
    MONTHLY: [1, 6126624],
    YEARLY: [1, 73519488],
  },
  TR: {
    HOURLY: [1, 2702],
    DAILY: [1, 24297],
    WEEKLY: [1, 121473],
    MONTHLY: [1, 506132],
    YEARLY: [1, 6073586],
  },
  TW: {
    HOURLY: [1, 25895],
    DAILY: [1, 207156],
    WEEKLY: [1, 1035777],
    MONTHLY: [1, 4315732],
    YEARLY: [1, 51788787],
  },
  UA: {
    HOURLY: [1, 721],
    DAILY: [1, 5766],
    WEEKLY: [1, 28832],
    MONTHLY: [1, 120132],
    YEARLY: [1, 1441584],
  },
  US: {
    HOURLY: [2, 536],
    DAILY: [30, 4285],
    WEEKLY: [40, 21424],
    MONTHLY: [100, 89266],
    YEARLY: [2000, 1071189],
  },
  UY: {
    HOURLY: [1, 549673],
    DAILY: [1, 4397384],
    WEEKLY: [1, 21986920],
    MONTHLY: [1, 91612167],
    YEARLY: [1, 1099346000],
  },
  VE: {
    HOURLY: [1, 168542],
    DAILY: [1, 1348339],
    WEEKLY: [1, 6741696],
    MONTHLY: [1, 28090625],
    YEARLY: [1, 337084800],
  },
  VN: {
    HOURLY: [1, 2671939],
    DAILY: [1, 21375513],
    WEEKLY: [1, 106877566],
    MONTHLY: [1, 445323191],
    YEARLY: [1, 5343878292],
  },
  ZA: {
    HOURLY: [1, 8783],
    DAILY: [1, 79039],
    WEEKLY: [1, 395192],
    MONTHLY: [1, 1646629],
    YEARLY: [1, 19759551],
  },
};

export const defaultPayBounds = payBoundsByCountry.US;
